import React, { useState, useEffect, useContext } from "react";
import "../../assets/FlpConsent/scss/style.scss";
import loader_img from "../../assets/img/loader-review2.svg";
import { useHistory } from "react-router-dom";
import { useFollowupLoad } from "../../Hooks/useFollowupLoad";
import { Api } from "../../api/Api";
import { getQueryString } from "../../Utility/QueryString";
import FlpconsentDetails from "./../../Components/Pages/FlpConsents/flpconsentDetails";
import FlpConsentLP from "./../../Components/Pages/FlpConsents/FlpConsentLP";
import FlpconsentFooter from "./../../Components/Pages/FlpConsents/FlpconsentFooter";
import logo from "../../assets/FlpConsent/img/logo.png";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import { usePageLoad } from "../../Hooks/usePageLoad";

const FlpConsent = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [showConsent, setShowConsent] = useState("hide");
  const history = useHistory();
  const { loadFollowup } = useFollowupLoad();
  const queryString = getQueryString() ?? window.location.search.substring(1);
  const [allFollowupData, setFollowupData] = useState();
  const [currentUuid, setCurrentUuid] = useState("");
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { savePageLoad, calledOnce } = usePageLoad();

 const trackVisitStatus = async (uuid, page_name, source) => {

  if (!uuid || !source) return;

    const data = {
      uuid,
      page_name,
      status: "visited",
      source,
    };

    await savePageLoad(uuid, data, "visited_status", "flp_consents", queryString);
  };

  const handleclick = async () => {
    setShowLoader(true);
    await trackVisitStatus(currentUuid, "flp_consents_proceed_btn_click", allFollowupData?.atp_sub6);
    setTimeout(() => {
      setShowLoader(false);
      window.scrollTo(0, 0);
      setShowConsent("show");
    }, 3000);
  };

  useEffect(() => {
    setShowLoader(true);
    setTimeout(() => {
        setShowLoader(false);
    }, 2000);
    (async () => {
      const response = await Api.get(
        `/api/v1/followup/get-pending-details-consent?query_string=` +
          queryString,
        {}
      );
      if (response.data.status === "Success") {
        let followupDetails1 = response.data.response.followup_data;
        let user_uuid = response.data.response.uuid;
        let showConsent = response.data.response.show_consent;

        setFollowupData(followupDetails1);
        setCurrentUuid(user_uuid);
        
        const flpResponse = await loadFollowup(
          "followup_load",
          followupDetails1,
          "followup-consents",
          queryString,
          "flp_consents"
        );

        const followupDetails = JSON.stringify(followupDetails1);
        localStorage.setItem("allFollowupData", followupDetails);   
        
      if (showConsent == "show") {
          await trackVisitStatus(user_uuid, "flp_consents_lp_visited", followupDetails1.atp_sub6);
          setShowConsent("hide");
        } else {
          history.push("/thankyouPageFlp?uuid=" + user_uuid);
        }
      } else {
        history.push("/thankyouPageFlp?uuid=" + response.data.response.uuid);
        return false;
      }
    })();
  }, []);

  const backClick = async () => {
    await trackVisitStatus(currentUuid, "flp_consents_back_btn_clicked", allFollowupData.atp_sub6);
    setShowConsent("hide");
    await trackVisitStatus(currentUuid, "flp_consents_lp_visited", allFollowupData.atp_sub6);

    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="FlpConsent">
        {showLoader && (
          <div
            className="text-center loader loader1"
            style={{ display: "block" }}
          >
            <div className="inner py-5">
              <div className="my-3">
                <img height="70" src={loader_img} alt="" />
              </div>
              <h2 className="px-4">Please wait...</h2>
            </div>
          </div>
        )}

        <FlpConsentLP showConsent={showConsent} handleclick={handleclick} />

        <FlpconsentDetails
          showConsent={showConsent}
          backClick={backClick}
          allFollowupData={allFollowupData}
          currentUuid={currentUuid}
        />
        <FlpconsentFooter logo_img={logo} />
      </div>
    </>
  );
};

export default FlpConsent;
